import { notification, Tag } from "antd";

const STATUS_CONFIG = {
  IP: { label: "In Preparation", color: "#faad14" },
  RC: { label: "Ready to Collect", color: "#1890ff" },
  CO: { label: "Completed", color: "#52c41a" },
  CL: { label: "Cancelled", color: "#ff4d4f" },
};

// Prevent duplicate notifications per order
const activeKDSOrders = new Set();

export const showKDSNotification = (order) => {
  if (!order?.orderId) return;

  if (activeKDSOrders.has(order.orderId)) return;
  activeKDSOrders.add(order.orderId);

  notification.open({
    key: order.orderId,
    placement: "topRight",
    duration: 4,
    message: <div style={{ fontWeight: 600 }}>🔔 Order No #{order.orderNo}</div>,
    description: (
      <div>
        {order?.items?.map((item, index) => {
          const config = STATUS_CONFIG[item.status] || {};
          return (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 6,
              }}
            >
              <span>{item.productName}</span>
              <Tag color={config.color}>{config.label || item.status}</Tag>
            </div>
          );
        })}
      </div>
    ),
    style: {
      borderLeft: `5px solid ${STATUS_CONFIG[order.status]?.color || "#1890ff"}`,
      borderRadius: 8,
    },
    onClose: () => {
      activeKDSOrders.delete(order.orderId);
    },
  });
};
